interface LogoProps {
  size?: 'sm' | 'md' | 'lg';
}

export function Logo({ size = 'md' }: LogoProps) {
  const dim = size === 'sm' ? 24 : size === 'lg' ? 40 : 32;
  const text = size === 'sm' ? 'text-base' : size === 'lg' ? 'text-2xl' : 'text-lg';

  return (
    <div className="flex items-center gap-2" aria-label="PocketLedger">
      <svg
        width={dim}
        height={dim}
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <rect width="64" height="64" rx="14" fill="#4F46E5" />
        <path
          d="M18 18 H38 a8 8 0 0 1 8 8 v2 a8 8 0 0 1 -8 8 H26 v12 H18 Z M26 24 v8 h11 a4 4 0 0 0 0 -8 Z"
          fill="#FFFFFF"
        />
        <circle cx="46" cy="46" r="4" fill="#14B8A6" />
      </svg>
      <span className={`font-semibold tracking-tight text-slate-900 ${text}`}>
        PocketLedger
      </span>
    </div>
  );
}
